import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Origem } from '../../../../home/common/origens/domain/origem';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-novo-origem-multi-select',
  templateUrl: './novo-origem-multi-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoOrigemMultiSelectComponent),
      multi: true
    }
  ]
})
export class NovoOrigemMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() origens: number[] = [];
  @Input() variante: 'filtro' | undefined;
  @Input() settings: Partial<IMultiSelectSettings>;

  @Output() changed = new EventEmitter<number[]>();

  options: IOption[] = [];
  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Origens',
    singular: 'Origem',
    plural: 'Origens',
    searchEmptyResultMessage: 'Nenhuma origem encontrada',
    showFooter: true
  };

  ngOnInit() {
    this.settings = {
      ...this.defaultSettings,
      ...this.settings
    };
    this.options = Origem.getAll().map((origem) => ({
      id: origem.id,
      label: origem.nome,
      isChecked: false
    }));
  }

  protected updateValue(newValue: number[] | null): void {
    this.origens = newValue || [];
  }

  onSelectionChange(): void {
    this.emitChange(this.origens);
  }

  onSearch(): void {
    this.changed.emit(this.origens);
  }
}
